import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import { useTableComponent } from './tableComponent/hook';
import ListerContext from './context';

const ListerFactory = ({ backendURL, viewType = 'lister' }) => (TableLister) => {
  ListerContext.displayName = `${viewType}  lister context of ${backendURL}`;

  function Lister({
    // eslint-disable-next-line no-unused-vars,react/prop-types
    choiceSettings,
    filter, noHierarchy, value, onSelect, onChoice, overridePermissions,
  }) {
    const options = useMemo(
      () => ({
        initialFilter: filter,
        initialValue: value,
        noHierarchy,
        onSelect,
        onChoice,
        // initialValue: value,
      }),
      [filter, noHierarchy, onChoice, onSelect, value],
    );
    const {
      visibleColumns, items, openedItems, selectedRows, onSetOrder, order, loading, err,
      showDeleted, searchString, period, maxItemLevel, localFilter, filterOpened, filteringFields,
      onReload,
      permissions,
      actions,
      columnSizes, onResizeColumn, onResetColumnSize, onSetColumnSizes,
      ctxMenu, onShowCtxMenu, onHideCtxMenu,
      tableRef, commandPanelRef, onRowFocusHandler, onTableScroll, areaSize,
      messages, meta,
    } = useTableComponent({
      backendURL,
      viewType,
      options,
    });

    const perms = useMemo(
      () => ({
        ...permissions,
        ...overridePermissions,
      }),
      [overridePermissions, permissions],
    );

    // При необходимости переместить одно ищ указанныъ нижу свойств в
    // context - удалять из свойств. Т.е. свойство должно быть или в
    // props или в context, но никак и там и там.
    const ctxValue = useMemo(
      () => ({
        permissions: perms,
        actions,
        showDeleted,
        searchString,
        period,
        selectedRows,
        items,
        localFilter,
        ctxMenu,
        onShowCtxMenu,
        onHideCtxMenu,
        backendURL,
        viewType,
        messages,
        filteringFields,
        meta,
      }),
      [actions, ctxMenu, filteringFields, items, localFilter, messages, meta, onHideCtxMenu,
        onShowCtxMenu, period, perms, searchString, selectedRows, showDeleted],
    );

    return (
      <ListerContext.Provider value={ctxValue}>
        <TableLister
          ref={tableRef}
          commandPanelRef={commandPanelRef}
          visibleColumns={visibleColumns}
          openedItems={openedItems}
          onRowFocus={onRowFocusHandler}
          onSetOrder={onSetOrder}
          order={order}
          loading={loading}
          err={err}
          onReoload={onReload}
          onScroll={onTableScroll}
          areaSize={areaSize}
          columnSizes={columnSizes}
          onResizeColumn={onResizeColumn}
          onResetColumnSize={onResetColumnSize}
          onSetColumnSizes={onSetColumnSizes}
          maxItemLevel={maxItemLevel}
          filterOpened={filterOpened}
        />
      </ListerContext.Provider>
    );
  }
  Lister.propTypes = {
    filter: PropTypes.shape({
    }),
    overridePermissions: PropTypes.shape({}),
    noHierarchy: PropTypes.bool,
    value: PropTypes.instanceOf(Map),
    onSelect: PropTypes.func,
    onChoice: PropTypes.func,
  };
  Lister.defaultProps = {
    filter: {},
    overridePermissions: {},
    noHierarchy: false,
    onSelect: null,
    onChoice: null,
    value: null,
  };
  return Lister;
};

export default ListerFactory;
